import type { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

/**
 * Plain table primitives styled like fuel's `DataTable`. The KPI and user lists need grouped rows, drag-and-drop
 * and row actions rather than sorting and paging, so they compose these directly.
 */
export const Table = ({ className, ...props }: HTMLAttributes<HTMLTableElement>) => (
  <div className="overflow-x-auto rounded-lg border border-border bg-card">
    <table
      className={cn('w-full border-collapse text-sm', className)}
      {...props}
    />
  </div>
);

export const TableHead = ({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) => (
  <thead
    className={cn('border-b border-border', className)}
    {...props}
  />
);

export const TableHeaderCell = ({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>) => (
  <th
    scope="col"
    className={cn('whitespace-nowrap px-4 py-3 text-start text-xs font-medium uppercase tracking-wide text-muted-foreground', className)}
    {...props}
  />
);

export const TableRow = ({ className, ...props }: HTMLAttributes<HTMLTableRowElement>) => (
  <tr
    className={cn('border-b border-border last:border-b-0', className)}
    {...props}
  />
);

export const TableCell = ({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>) => (
  <td
    className={cn('px-4 py-2.5 text-start align-middle text-foreground', className)}
    {...props}
  />
);
